import React from "react"
import styled from "styled-components"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  h2Styles,
  h3Styles,
  h4Styles,
  paragraphStyles,
} from "@constants/typography"

export const Container = styled.div`
  padding: 86px 20px 92px;

  @media ${breakpoints.laptop} {
    padding: 130px calc(3 / 12 * 100vw) 215px calc(2 / 12 * 100vw);
  }
`

const Content = styled.div`
  h2 {
    ${h3Styles}
    width: 60%;
    margin-bottom: 32px;
    word-break: normal;

    @media ${breakpoints.laptop} {
      width: 100%;
      margin-bottom: 65px;
    }

    @media ${breakpoints.desktop} {
      ${h2Styles}
      margin-bottom: 65px;
    }
  }

  h3 {
    ${h4Styles}
    width: 60%;
    margin: 24px 0 16px;

    @media ${breakpoints.laptop} {
      width: 100%;
      margin: 48px 0 32px;
    }

    @media ${breakpoints.desktop} {
      ${h3Styles}
      margin: 48px 0 32px;
    }
  }

  p {
    ${paragraphStyles}
    margin-bottom: 24px;
    color: ${colors.mediumDarkGray};
  }

  ul {
    margin: 0 0 24px;
    padding-left: 18px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  li {
    color: ${colors.mediumDarkGray};

    p {
      ${paragraphStyles}
      color: ${colors.mediumDarkGray};
    }
  }

  @media ${breakpoints.laptop} {
    p {
      ${paragraphStyles}
      margin-bottom: 30px;
      color: ${colors.mediumDarkGray};
    }

    ul {
      margin-bottom: 30px;
    }

    li {
      p {
        ${paragraphStyles}
        color: ${colors.mediumDarkGray};
      }
    }
  }
`

interface LegalContentProps {
  blockId?: string
  content: React.ReactNode
}

const LegalContent: React.FC<LegalContentProps> = ({ blockId, content }) => {
  return (
    <Container id={blockId || undefined}>
      <Content>{content}</Content>
    </Container>
  )
}

export default LegalContent
